<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form
                ref="form"
                v-bind:rules="rules"
                v-bind:model="form"
                label-position="right"
                label-suffix=":"
                size="large"
                label-width="120px"
                class="dialog_box"
            >
                <div class="block-head">基本信息</div>
                <el-form-item label="专场名称" prop="name">
                    <el-input
                        type="text"
                        auto-complete="off"
                        v-model="form.name"
                        placeholder="请输入名称"
                        style="margin-bottom: 10px"
                        maxlength="10"
                        show-word-limit
                        class="input-width"
                    ></el-input>
                </el-form-item>
                <el-form-item label="专场描述" prop="desc">
                    <el-input
                        type="text"
                        auto-complete="off"
                        v-model="form.desc"
                        placeholder="请输入名称"
                        style="margin-bottom: 10px"
                        maxlength="30"
                        show-word-limit
                        class="input-width"
                    ></el-input>
                </el-form-item>

                <el-form-item label="专场位置" prop="position">
                    <el-select v-model="form.position" placeholder="请选择位置" class="handle-select mr10 input-width">
                        <el-option v-for="items in positionList" :key="items.index" :label="items.name" :value="items.key"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="关联门店" prop="shop_id_list">
                    <el-select v-model="form.shop_id_list" multiple placeholder="请选择门店"
                               class="handle-select mr10 input-width" filterable remote :remote-method="shopListSearch"
                               :loading="loading">
                      <el-option v-for="items in shopList" :key="items.shop_id" :label="items.shop_name_alias"
                                 :value="items.shop_id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="专场标签" prop="tagJson">
                    <div class="disflex">
                        <div
                            v-for="(item, index) in form.tagList"
                            :key="index"
                            :style="`border-color:${item.bgColor};color:${item.bgColor}`"
                            class="setTag"
                        >
                            {{ item.name }}
                            <i class="el-icon-close" :style="`color:${item.bgColor} !important`" @click="tagClose(index)"></i>
                        </div>

                        <el-button class="button-new-tag" size="small" @click="showtag">添加标签</el-button>
                    </div>

                    <!-- </div> -->
                </el-form-item>

                <el-form-item label="排序" prop="r">
                    <el-input placeholder="数字越大排名越靠前" v-model="form.r" style="margin-bottom: 10px"></el-input>
                </el-form-item>
                <el-form-item label="起止时间" prop="time">
                    <el-date-picker
                        style="margin-bottom: 10px"
                        v-model="form.time"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="活动开始日期"
                        end-placeholder="活动结束日期"
                        v-on:change="changeDatePicker"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="是否推荐" prop="is_recommand">
                    <el-radio-group v-model="form.is_recommand">
                        <el-radio :label="2">是</el-radio>
                        <el-radio :label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="专场logo" prop="logo">
                    <ImgSingleUpload :value.sync="form.logo" :imgType="['png']" />
                    <span class="span_gray">图片格式：png,规格100*100px</span>
                </el-form-item>
                <el-form-item label="首页封面图" prop="thumbs">
                    <Imgupload v-model="form.thumbs" :limit="1" :ImgVisible="ImgVisible" @changeImg="changeImg" @changetext="changetext" />
                    <span class="span_gray">入口封面banner，图片格式:png、jpg，规格:750*320px，可为空，不上传则不显示</span>
                </el-form-item>
                <el-form-item label="专场海报" prop="poster">
                    <ImgSingleUpload :value.sync="form.poster" />
                    <span class="span_gray">生成专场海报和分享小程序卡片显示的海报图，规格800*600px可为空，</span>
                    <span class="span_gray">不上传则显示默认小程序专场详情页</span>
                </el-form-item>
                <el-form-item label="专场封面" prop="image">
                    <ImgSingleUpload :value.sync="form.image" :imgType="['png', 'jpg']" />
                    <span class="span_gray">专场详情顶部显示的封面，图片格式：png、jpg，建议规格750*320px，高度自适应</span>
                </el-form-item>

                <el-form-item label="按钮文案" prop="name">
                    <el-input
                        type="text"
                        auto-complete="off"
                        v-model="form.facade_widget.entry_button.text"
                        placeholder="请输入按钮文案"
                        style="margin-bottom: 10px"
                        maxlength="10"
                        show-word-limit
                        class="input-width"
                    ></el-input>
                </el-form-item>
                <el-form-item label="价格文案" prop="name">
                    <el-input
                        type="text"
                        auto-complete="off"
                        v-model="form.facade_widget.product_price.text"
                        placeholder="请输入价格文案"
                        style="margin-bottom: 10px"
                        maxlength="10"
                        show-word-limit
                        class="input-width"
                    ></el-input>
                </el-form-item>

                <el-form-item label="样式示例" prop="style_mode">
                    <div class="disflex">
                        <div :class="{ styleModeItemSelect: form.style_mode == '1' }" @click="setStyleMode('1')" style="margin-right: 30px">
                            <styleInstance1 :data="form" />
                        </div>
                        <div :class="{ styleModeItemSelect: form.style_mode == '2' }" @click="setStyleMode('2')">
                            <styleInstance2 :data="form" />
                        </div>
                    </div>
                    <!-- <div
                        class="style-mode-item"
                        style="float: left"
                        v-for="(item, index) in styleModeList"
                        :key="index"
                        @click="selectStyleModeByImg(item.modeValue)"
                    >
                        <el-image :class="{ styleModeItemSelect: item.modeValue === form.style_mode }" fit="fill" :src="item.thumb">
                            <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
                        </el-image>
                    </div> -->
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm">保 存</el-button>
                    <el-button @click="cancel">取 消</el-button>
                </el-form-item>
                <!-- 选择图片对话框 -->
                <div class="img">
                    <Picture :ImgVisible="ImgVisible" @toggleImg="toggleImg" @getImg="getImg"></Picture>
                </div>
            </el-form>
        </div>

        <!-- 新增标签 -->
        <el-dialog title="添加标签" :visible.sync="addTagsShow" @close="addTagsLabelclose" width="40%">
            <div>
                <div>自定义标签</div>
                <div style="display: flex; background-color: #f5f5f5">
                    <div style="flex: 1; display: flex; padding: 7px 0">
                        <el-input
                            v-model="tagInput"
                            placeholder="请输入标签"
                            maxlength="10"
                            show-word-limit
                            style="width: 200px; margin-left: 20px"
                        ></el-input>
                        <div style="display: flex; align-items: center; margin-left: 20px">
                            标签颜色
                            <el-color-picker v-model="tagColor" size="mini"></el-color-picker>
                        </div>
                    </div>

                    <!-- <el-button type="text" style="width: 120px" @click="addTags" :loading="tagsLoading">新增+</el-button> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addTagsLabelclose">取 消</el-button>
                <el-button type="primary" @click="submitTag" :loading="tagSubmitLoading">添 加</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import { fetchData } from '@/api/index';
import loadEvents from '@/utils/loading';
import Imgupload from '@/components/Imgupload';
import ImgSingleUpload from '@/components/ImgSingleUpload';
import { deal } from '@/common/main';
import bus from '@/common/bus';
import Picture from '@/components/Picture';
import { request } from '@/common/request';
import { IMAGE_UPLOAD_PRO_URL } from '../../common/const';
import styleInstance2 from '@/page/activity/components/styleInstance2.vue';
import styleInstance1 from '@/page/activity/components/styleInstance1.vue';

const { StyleModeList } = require('@/common/const');
let loads = new loadEvents();
let id = 0;
export default {
    name: 'StoreInfo',
    components: {
        styleInstance1,
        styleInstance2,
        Breadcrumb,
        ImgSingleUpload,
        Imgupload,
        Picture
    },
    data() {
        return {
            IMAGE_UPLOAD_PRO_URL: IMAGE_UPLOAD_PRO_URL,
            ImgVisible: false,
            text: 'image',
            menuList: ['营销', '添加专场'],
            loading: false,
            rules: {
                name: [
                    {
                        required: true,
                        message: '活动名称不能为空',
                        trigger: 'blur'
                    }
                ],
                time: [
                    {
                        required: true,
                        message: '活动时间不能为空',
                        trigger: 'blur'
                    }
                ],
                logo: [{ validator: deal.checkImage, trigger: ['blur', 'change'] }],
                //thumbs: [{ validator: deal.checkImage, trigger: ['blur', 'change'] }],
                poster: [{ validator: deal.checkImage, trigger: ['blur', 'change'] }],
                image: [{ validator: deal.checkImage, trigger: ['blur', 'change'] }],
                desc: [
                    {
                        required: true,
                        message: '描述不能为空',
                        trigger: 'blur'
                    }
                ],
                r: [
                    {
                        required: true,
                        message: '专场排序不能为空',
                        trigger: ['blur', 'change']
                    },
                    {
                        pattern: '^[0-9]*$',
                        message: '只能输入数字'
                    }
                ],
                position: [
                    {
                        required: true,
                        message: '专场位置不能为空',
                        trigger: 'blur'
                    }
                ],
                shop_id_list: [
                    {
                        required: false,
                        message: '请选择关联门店',
                        trigger: 'change'
                    }
                ],
                is_recommand: [
                    {
                        required: true,
                        message: '是否推荐未选择',
                        trigger: 'blur'
                    }
                ]
            },
            mode: 'add',
            selectGoodsList: [],
            positionList: [],
            platformList: [],
            form: {
                name: '',
                stime: '',
                etime: '',
                logo: '',
                image: '',
                poster: '',
                thumbs: [],
                desc: '',
                is_recommand: 2,
                style_mode: '0',
                shop_id_list: [], // 关联门店ID列表
                facade_widget: {
                    entry_button: {
                        text: '进入专场',
                        type: '',
                        name: '',
                        background_color: '',
                        color: ''
                    },
                    product_price: {
                        text: '秒杀价',
                        color: ''
                    }
                },
                tagList: []
            },
            header: {},
            styleModeList: StyleModeList,

            tagName: '',
            tagSubmitLoading: false,
            tagInput: '',
            tagColor: '',
            tagsLoading: false,
            addTagsShow: false, // 添加标签
            tagList: [
                {
                    name: '',
                    bgColor: ''
                }
            ],
            shopList: [], // 门店列表
            originalShopList: [] // 原始门店列表，用于搜索
        };
    },
    created() {
        deal.getconf('special', this);
        this.tagList = [];
        this.getShopList(); // 添加获取门店列表
    },
    methods: {
        toggleImg(val) {
            // 关闭 img对话框
            this.ImgVisible = val;
        },
        choiceImg(text) {
            this.text = text;
            this.ImgVisible = true;
        },
        getImg(url) {
            // 获取选择的img
            if (this.text === 'many') {
                if (this.form.thumbs.length < 9) {
                    this.form.thumbs.push(url);
                } else {
                    this.$message({ type: 'error', message: '最多上传九张图片' });
                }
            } else {
                this.$set(this.form, this.text, url);
            }
        },
        saveData(ret) {
            this.form.goodsList = this.selectGoodsList;
            this.addVisible = false;
        },
        changeImg(val) {
            this.ImgVisible = val;
        },
        changetext(val) {
            this.text = val;
        },

        submitForm() {
            if (this.$refs.form) {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        var url = '/goods/special/add';
                        //处理时间
                        let param = Object.assign({}, this.form);
                        param.thumbs = this.form.thumbs.join(',');
                        param.stime = deal.timestamp(this.form.time[0]);
                        param.etime = deal.timestamp(this.form.time[1]);
                        param.tag_list = JSON.stringify(this.form.tagList);
                        param.facade_widget_json = JSON.stringify(this.form.facade_widget);
                        // 添加门店ID列表处理
                        param.shop_id_list = JSON.stringify( this.form.shop_id_list);
                        request.post(url, param).then((ret) => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.$message.success('添加成功');
                                bus.$emit('close_current_tags', '/activity-PlaceEdit');
                                this.$router.push({ path: '/activity-Session' });
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
        // 取消按钮
        cancel() {
            bus.$emit('close_current_tags', '/community-LettresAdd');
            this.$router.push({ path: '/Session' });
        },
        changeDatePicker: function () {},
        // 专场通过图片选择展示的样式
        selectStyleModeByImg(modeValue) {
            this.form.style_mode = modeValue;
        },
        showtag() {
            this.addTagsShow = true;
        },
        // 关闭tag
        handleClose(index) {
            this.tagList.splice(index, 1);
            this.state = '';
        },
        addTagsLabelclose() {
            this.addTagsShow = false;
        },

        submitTag() {
            if (!this.tagInput) {
                this.$message({
                    message: '请输入内容',
                    type: 'error'
                });

                return false;
            }

            this.form.tagList.push({ name: this.tagInput, bgColor: this.tagColor });

            this.tagInput = '';
            this.tagColor = '';
            this.addTagsShow = false;
        },

        tagClose(index) {
            this.form.tagList.splice(index, 1);
        },

        setStyleMode(type) {
            this.form.style_mode = type;
        },
        // 门店搜索方法（支持remote）
        async shopListSearch(query) {
            if (query !== '') {
                this.loading = true;
                try {
                    // 使用正确的API端点进行搜索
                    const response = await request.get('/account/merchant/hotfan/shopList', {
                        params: {
                            shop_name: query, // 使用接口支持的参数
                            page: 1,
                            pagesize: 999
                        }
                    });
                    if (response.code === 1) {
                        // 根据接口响应结构调整数据处理
                        const shopData = response.data.list || [];
                        this.shopList = shopData
                    } else {
                        this.$message.error(response.msg || '搜索门店失败');
                        this.shopList = [];
                    }
                } catch (error) {
                    console.error('搜索门店错误:', error);
                    this.$message.error('搜索门店失败');
                    this.shopList = [];
                } finally {
                    this.loading = false;
                }
            } else {
                // 如果搜索关键词为空，获取全部门店列表
                this.getShopList();
            }
        },

        // 获取门店列表数据
        async getShopList() {
            try {
                this.loading = true;
                // 使用正确的API端点，根据接口文档
                const response = await request.get('/account/merchant/hotfan/shopList', {
                    params: {
                        page: 1,
                        pagesize: 100 // 设置一个较大的页面大小以获取所有门店
                    }
                });
                if (response.code === 1) {
                    // 根据接口响应结构调整数据处理
                    const shopData = response.data.list || [];
                    // 将接口返回的门店数据映射为下拉框需要的格式
                    this.originalShopList = shopData
                    this.shopList = this.originalShopList;
                } else {
                    this.$message.error(response.msg || '获取门店列表失败');
                }
            } catch (error) {
                console.error('获取门店列表错误:', error);
                this.$message.error('获取门店列表失败');
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

.disflex {
    display: flex;
    align-items: center;
}

.setTag {
    border: 1px solid;
    margin-right: 10px;
    padding: 2px 30px 2px 15px;
    line-height: normal !important;
    border-radius: 3px;
    position: relative;
}

.setTag .el-icon-close {
    font-size: 12px;
    position: absolute;
    right: 5px;
    top: 50%;
    margin-top: -6px;
    cursor: pointer;
}

::v-deep .setTag .el-icon-close {
    color: #fff !important;
}

.input-width {
    width: 15vw !important;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

/* 图片样式 */
.dialog_box .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.dialog_box .avatar {
    font-size: 28px;
    width: 100px;
    height: 100px;
    line-height: 100px;
}

.dialog_box .span_gray {
    font-size: 12px;
    color: gray;
}

.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}
/* 选择链接样式 */
.dialog_box .el-button {
    margin-left: 20px;
}

.style-mode-radio {
    margin-right: 20px;
}
.style-mode-item {
    width: 280px;
}
.style-mode-item img {
    float: left;
    overflow: hidden;
}

.styleModeItemSelect {
    border: 2px red solid !important;
    border-radius: 5px;
}
</style>